<template>
  <div :class="['titleBox', {'bg-style': isShowBg}]">
    <span class="title-color-box"></span>
    <span class="tips" :style="styleObj ? styleObj : ''">{{ label }}</span>
		<slot name="slotBox"></slot>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    styleTitleObj: {
      type: Object,
      default: () => ({}),
    },
    isShowBg: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    styleObj() {
      return this.styleTitleObj ? this.styleTitleObj : {};
    },
  },
};
</script>

<style lang="scss" scoped>
.titleBox {
  display: flex;
  align-items: center;
  .title-color-box {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: $theme-color;
    opacity: 1;
    margin-right: 8px;
    border-radius: 1px;
  }
  .tips {
    color: #333333;
    font-size: 14px !important;
    line-height: 17px;
    font-weight: bold;
  }
  .desc {
    color: #666666;
    margin-left: 8px;
    font-size: 12px;
  }
}

.bg-style {
  width: 100%;
  padding: 5px 8px;
  background-color: #F7F8FA;
}
</style>
